// This file is auto-generated by @hey-api/openapi-ts

import type {
  ApiError,
  GetHostedBusinessData,
  GetHostedBusinessesData,
  GetHostedBusinessOwnersData,
  GetHostedCheckSessionData,
  GetHostedIdentifySessionRequirementsData,
  GetHostedOnboardingConfigData,
  GetHostedOnboardingNidData,
  GetHostedOnboardingPrefillData,
  GetHostedOnboardingPrivacyPassData,
  GetHostedOnboardingStatusData,
  GetHostedUserAuthMethodsData,
  GetHostedUserAuthorizedOrgsData,
  GetHostedUserPrivateTokenData,
  GetHostedUserTokenData,
  GetOrgSdkArgsData,
  HostedOnboardingD2pGenerateData,
  HostedOnboardingD2pGenerateResponse,
  HostedOnboardingD2pSmsData,
  HostedOnboardingD2pSmsResponse,
  HostedOnboardingD2pStatusData,
  HostedOnboardingD2pStatusPostData,
  HostedOnboardingD2pStatusPostResponse,
  PatchHostedBusinessOwnersData,
  PatchHostedBusinessOwnersResponse,
  PatchHostedBusinessVaultData,
  PatchHostedBusinessVaultResponse,
  PatchHostedIdentifySessionVaultData,
  PatchHostedIdentifySessionVaultResponse,
  PatchHostedUserVaultData,
  PatchHostedUserVaultResponse,
  PostHostedBusinessOnboardingData,
  PostHostedBusinessOnboardingResponse,
  PostHostedBusinessVaultDecryptData,
  PostHostedBusinessVaultDecryptResponse,
  PostHostedBusinessVaultValidateData,
  PostHostedBusinessVaultValidateResponse,
  PostHostedDocumentsByIdProcessData,
  PostHostedDocumentsByIdProcessResponse,
  PostHostedDocumentsByIdUploadBySideData,
  PostHostedDocumentsByIdUploadBySideResponse,
  PostHostedDocumentsData,
  PostHostedDocumentsResponse,
  PostHostedIdentifySessionChallengeData,
  PostHostedIdentifySessionChallengeResponse,
  PostHostedIdentifySessionChallengeVerifyData,
  PostHostedIdentifySessionChallengeVerifyResponse,
  PostHostedIdentifySessionData,
  PostHostedIdentifySessionKbaData,
  PostHostedIdentifySessionKbaResponse,
  PostHostedIdentifySessionResponse,
  PostHostedIdentifySessionVerifyData,
  PostHostedIdentifySessionVerifyResponse,
  PostHostedIdentifyValidationTokenData,
  PostHostedIdentifyValidationTokenResponse,
  PostHostedOnboardingAuthorizeData,
  PostHostedOnboardingAuthorizeResponse,
  PostHostedOnboardingAvisResultData,
  PostHostedOnboardingAvisResultResponse,
  PostHostedOnboardingBackData,
  PostHostedOnboardingBackResponse,
  PostHostedOnboardingChallengeData,
  PostHostedOnboardingChallengeResponse,
  PostHostedOnboardingChallengeVerifyData,
  PostHostedOnboardingChallengeVerifyResponse,
  PostHostedOnboardingData,
  PostHostedOnboardingFpData,
  PostHostedOnboardingFpResponse,
  PostHostedOnboardingPrefillChallengeData,
  PostHostedOnboardingPrefillChallengeResponse,
  PostHostedOnboardingPrefillData,
  PostHostedOnboardingPrefillResponse,
  PostHostedOnboardingPrefillVerifiedCommitData,
  PostHostedOnboardingPrefillVerifiedCommitResponse,
  PostHostedOnboardingPrefillVerifiedData,
  PostHostedOnboardingPrefillVerifiedResponse,
  PostHostedOnboardingProceedData,
  PostHostedOnboardingProceedResponse,
  PostHostedOnboardingProcessData,
  PostHostedOnboardingProcessResponse,
  PostHostedOnboardingResponse,
  PostHostedOnboardingSdsData,
  PostHostedOnboardingSdsResponse,
  PostHostedOnboardingSilentData,
  PostHostedOnboardingSilentResponse,
  PostHostedOnboardingSkipPasskeyRegisterData,
  PostHostedOnboardingSkipPasskeyRegisterResponse,
  PostHostedOnboardingTelData,
  PostHostedOnboardingTelResponse,
  PostHostedOnboardingTimelineData,
  PostHostedOnboardingTimelineResponse,
  PostHostedOnboardingValidateData,
  PostHostedOnboardingValidateResponse,
  PostHostedSdkVersionData,
  PostHostedSdkVersionResponse,
  PostHostedUserAttestDeviceChallengeData,
  PostHostedUserAttestDeviceChallengeResponse,
  PostHostedUserAttestDeviceData,
  PostHostedUserAttestDeviceResponse,
  PostHostedUserChallengeData,
  PostHostedUserChallengeResponse,
  PostHostedUserChallengeVerifyData,
  PostHostedUserChallengeVerifyResponse,
  PostHostedUserConsentData,
  PostHostedUserConsentResponse,
  PostHostedUserDocumentsByIdProcessData,
  PostHostedUserDocumentsByIdProcessResponse,
  PostHostedUserDocumentsByIdUploadBySideData,
  PostHostedUserDocumentsByIdUploadBySideResponse,
  PostHostedUserDocumentsData,
  PostHostedUserDocumentsResponse,
  PostHostedUserEmailVerifyData,
  PostHostedUserEmailVerifyResponse,
  PostHostedUserExpireSessionData,
  PostHostedUserExpireSessionResponse,
  PostHostedUserTokensData,
  PostHostedUserTokensResponse,
  PostHostedUserUploadByDocumentIdentifierData,
  PostHostedUserUploadByDocumentIdentifierResponse,
  PostHostedUserVaultDecryptData,
  PostHostedUserVaultDecryptResponse,
  PostHostedUserVaultValidateData,
  PostHostedUserVaultValidateResponse,
  PostOrgSdkArgsData,
  PostOrgSdkArgsResponse,
  PostOrgSdkTelemetryData,
  PostOrgSdkTelemetryResponse,
} from '@onefootprint/request-types';
import { queryOptions, type UseMutationOptions } from '@tanstack/react-query';
import { client as _heyApiClient } from '../client.gen';
import {
  getHostedBusiness,
  getHostedBusinesses,
  getHostedBusinessOwners,
  getHostedCheckSession,
  getHostedIdentifySessionRequirements,
  getHostedOnboardingConfig,
  getHostedOnboardingNid,
  getHostedOnboardingPrefill,
  getHostedOnboardingPrivacyPass,
  getHostedOnboardingStatus,
  getHostedUserAuthMethods,
  getHostedUserAuthorizedOrgs,
  getHostedUserPrivateToken,
  getHostedUserToken,
  getOrgSdkArgs,
  hostedOnboardingD2pGenerate,
  hostedOnboardingD2pSms,
  hostedOnboardingD2pStatus,
  hostedOnboardingD2pStatusPost,
  type Options,
  patchHostedBusinessOwners,
  patchHostedBusinessVault,
  patchHostedIdentifySessionVault,
  patchHostedUserVault,
  postHostedBusinessOnboarding,
  postHostedBusinessVaultDecrypt,
  postHostedBusinessVaultValidate,
  postHostedDocuments,
  postHostedDocumentsByIdProcess,
  postHostedDocumentsByIdUploadBySide,
  postHostedIdentifySession,
  postHostedIdentifySessionChallenge,
  postHostedIdentifySessionChallengeVerify,
  postHostedIdentifySessionKba,
  postHostedIdentifySessionVerify,
  postHostedIdentifyValidationToken,
  postHostedOnboarding,
  postHostedOnboardingAuthorize,
  postHostedOnboardingAvisResult,
  postHostedOnboardingBack,
  postHostedOnboardingChallenge,
  postHostedOnboardingChallengeVerify,
  postHostedOnboardingFp,
  postHostedOnboardingPrefill,
  postHostedOnboardingPrefillChallenge,
  postHostedOnboardingPrefillVerified,
  postHostedOnboardingPrefillVerifiedCommit,
  postHostedOnboardingProceed,
  postHostedOnboardingProcess,
  postHostedOnboardingSds,
  postHostedOnboardingSilent,
  postHostedOnboardingSkipPasskeyRegister,
  postHostedOnboardingTel,
  postHostedOnboardingTimeline,
  postHostedOnboardingValidate,
  postHostedSdkVersion,
  postHostedUserAttestDevice,
  postHostedUserAttestDeviceChallenge,
  postHostedUserChallenge,
  postHostedUserChallengeVerify,
  postHostedUserConsent,
  postHostedUserDocuments,
  postHostedUserDocumentsByIdProcess,
  postHostedUserDocumentsByIdUploadBySide,
  postHostedUserEmailVerify,
  postHostedUserExpireSession,
  postHostedUserTokens,
  postHostedUserUploadByDocumentIdentifier,
  postHostedUserVaultDecrypt,
  postHostedUserVaultValidate,
  postOrgSdkArgs,
  postOrgSdkTelemetry,
} from '../sdk.gen';

export type QueryKey<TOptions extends Options> = [
  Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
    _id: string;
    _infinite?: boolean;
  },
];

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  infinite?: boolean,
): [QueryKey<TOptions>[0]] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseUrl: (options?.client ?? _heyApiClient).getConfig().baseUrl,
  } as QueryKey<TOptions>[0];
  if (infinite) {
    params._infinite = infinite;
  }
  if (options?.body) {
    params.body = options.body;
  }
  if (options?.headers) {
    params.headers = options.headers;
  }
  if (options?.path) {
    params.path = options.path;
  }
  if (options?.query) {
    params.query = options.query;
  }
  return [params];
};

export const getHostedBusinessQueryKey = (options?: Options<GetHostedBusinessData>) =>
  createQueryKey('getHostedBusiness', options);

/**
 * Get information about the business for which we started a KYC of a beneficial owner
 */
export const getHostedBusinessOptions = (options?: Options<GetHostedBusinessData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getHostedBusiness({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getHostedBusinessQueryKey(options),
  });
};

export const postHostedBusinessOnboardingQueryKey = (options: Options<PostHostedBusinessOnboardingData>) =>
  createQueryKey('postHostedBusinessOnboarding', options);

/**
 * Gets or creates the business Onboarding, optionally accepting an existing business. You can select an existing business from the results of `GET /hosted/businesses`.
 */
export const postHostedBusinessOnboardingOptions = (options: Options<PostHostedBusinessOnboardingData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postHostedBusinessOnboarding({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postHostedBusinessOnboardingQueryKey(options),
  });
};

/**
 * Gets or creates the business Onboarding, optionally accepting an existing business. You can select an existing business from the results of `GET /hosted/businesses`.
 */
export const postHostedBusinessOnboardingMutation = (
  options?: Partial<Options<PostHostedBusinessOnboardingData>>,
): UseMutationOptions<PostHostedBusinessOnboardingResponse, ApiError, Options<PostHostedBusinessOnboardingData>> => {
  const mutationOptions: UseMutationOptions<
    PostHostedBusinessOnboardingResponse,
    ApiError,
    Options<PostHostedBusinessOnboardingData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postHostedBusinessOnboarding({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getHostedBusinessOwnersQueryKey = (options?: Options<GetHostedBusinessOwnersData>) =>
  createQueryKey('getHostedBusinessOwners', options);

/**
 * Get information about the beneficial owners of this business
 */
export const getHostedBusinessOwnersOptions = (options?: Options<GetHostedBusinessOwnersData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getHostedBusinessOwners({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getHostedBusinessOwnersQueryKey(options),
  });
};

/**
 * Applies multiple operations in batch to update or create business owners. NOTE: the open API documentation for the request is extremely incorrect for this API.
 */
export const patchHostedBusinessOwnersMutation = (
  options?: Partial<Options<PatchHostedBusinessOwnersData>>,
): UseMutationOptions<PatchHostedBusinessOwnersResponse, ApiError, Options<PatchHostedBusinessOwnersData>> => {
  const mutationOptions: UseMutationOptions<
    PatchHostedBusinessOwnersResponse,
    ApiError,
    Options<PatchHostedBusinessOwnersData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await patchHostedBusinessOwners({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Updates data in a business vault. Can be used to update `business.` data
 */
export const patchHostedBusinessVaultMutation = (
  options?: Partial<Options<PatchHostedBusinessVaultData>>,
): UseMutationOptions<PatchHostedBusinessVaultResponse, ApiError, Options<PatchHostedBusinessVaultData>> => {
  const mutationOptions: UseMutationOptions<
    PatchHostedBusinessVaultResponse,
    ApiError,
    Options<PatchHostedBusinessVaultData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await patchHostedBusinessVault({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postHostedBusinessVaultDecryptQueryKey = (options: Options<PostHostedBusinessVaultDecryptData>) =>
  createQueryKey('postHostedBusinessVaultDecrypt', options);

/**
 * Decrypts the specified list of fields from the provided vault.
 */
export const postHostedBusinessVaultDecryptOptions = (options: Options<PostHostedBusinessVaultDecryptData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postHostedBusinessVaultDecrypt({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postHostedBusinessVaultDecryptQueryKey(options),
  });
};

/**
 * Decrypts the specified list of fields from the provided vault.
 */
export const postHostedBusinessVaultDecryptMutation = (
  options?: Partial<Options<PostHostedBusinessVaultDecryptData>>,
): UseMutationOptions<
  PostHostedBusinessVaultDecryptResponse,
  ApiError,
  Options<PostHostedBusinessVaultDecryptData>
> => {
  const mutationOptions: UseMutationOptions<
    PostHostedBusinessVaultDecryptResponse,
    ApiError,
    Options<PostHostedBusinessVaultDecryptData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postHostedBusinessVaultDecrypt({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postHostedBusinessVaultValidateQueryKey = (options: Options<PostHostedBusinessVaultValidateData>) =>
  createQueryKey('postHostedBusinessVaultValidate', options);

/**
 * Checks if provided vault data is valid before adding it to the business vault
 */
export const postHostedBusinessVaultValidateOptions = (options: Options<PostHostedBusinessVaultValidateData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postHostedBusinessVaultValidate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postHostedBusinessVaultValidateQueryKey(options),
  });
};

/**
 * Checks if provided vault data is valid before adding it to the business vault
 */
export const postHostedBusinessVaultValidateMutation = (
  options?: Partial<Options<PostHostedBusinessVaultValidateData>>,
): UseMutationOptions<
  PostHostedBusinessVaultValidateResponse,
  ApiError,
  Options<PostHostedBusinessVaultValidateData>
> => {
  const mutationOptions: UseMutationOptions<
    PostHostedBusinessVaultValidateResponse,
    ApiError,
    Options<PostHostedBusinessVaultValidateData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postHostedBusinessVaultValidate({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getHostedBusinessesQueryKey = (options?: Options<GetHostedBusinessesData>) =>
  createQueryKey('getHostedBusinesses', options);

/**
 * Get information about the businesses owned by the authenticated user
 */
export const getHostedBusinessesOptions = (options?: Options<GetHostedBusinessesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getHostedBusinesses({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getHostedBusinessesQueryKey(options),
  });
};

export const getHostedCheckSessionQueryKey = (options?: Options<GetHostedCheckSessionData>) =>
  createQueryKey('getHostedCheckSession', options);

/**
 * Checks a hosted session token for expiration/validity
 */
export const getHostedCheckSessionOptions = (options?: Options<GetHostedCheckSessionData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getHostedCheckSession({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getHostedCheckSessionQueryKey(options),
  });
};

export const postHostedDocumentsQueryKey = (options: Options<PostHostedDocumentsData>) =>
  createQueryKey('postHostedDocuments', options);

/**
 * Create a new document for the outstanding document request
 */
export const postHostedDocumentsOptions = (options: Options<PostHostedDocumentsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postHostedDocuments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postHostedDocumentsQueryKey(options),
  });
};

/**
 * Create a new document for the outstanding document request
 */
export const postHostedDocumentsMutation = (
  options?: Partial<Options<PostHostedDocumentsData>>,
): UseMutationOptions<PostHostedDocumentsResponse, ApiError, Options<PostHostedDocumentsData>> => {
  const mutationOptions: UseMutationOptions<PostHostedDocumentsResponse, ApiError, Options<PostHostedDocumentsData>> = {
    mutationFn: async localOptions => {
      const { data } = await postHostedDocuments({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postHostedDocumentsByIdProcessQueryKey = (options: Options<PostHostedDocumentsByIdProcessData>) =>
  createQueryKey('postHostedDocumentsByIdProcess', options);

/**
 * Process the document and run any vendor verifications.
 */
export const postHostedDocumentsByIdProcessOptions = (options: Options<PostHostedDocumentsByIdProcessData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postHostedDocumentsByIdProcess({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postHostedDocumentsByIdProcessQueryKey(options),
  });
};

/**
 * Process the document and run any vendor verifications.
 */
export const postHostedDocumentsByIdProcessMutation = (
  options?: Partial<Options<PostHostedDocumentsByIdProcessData>>,
): UseMutationOptions<
  PostHostedDocumentsByIdProcessResponse,
  ApiError,
  Options<PostHostedDocumentsByIdProcessData>
> => {
  const mutationOptions: UseMutationOptions<
    PostHostedDocumentsByIdProcessResponse,
    ApiError,
    Options<PostHostedDocumentsByIdProcessData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postHostedDocumentsByIdProcess({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postHostedDocumentsByIdUploadBySideQueryKey = (
  options: Options<PostHostedDocumentsByIdUploadBySideData>,
) => createQueryKey('postHostedDocumentsByIdUploadBySide', options);

/**
 * Upload an image for the given side to the provided document.
 */
export const postHostedDocumentsByIdUploadBySideOptions = (
  options: Options<PostHostedDocumentsByIdUploadBySideData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postHostedDocumentsByIdUploadBySide({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postHostedDocumentsByIdUploadBySideQueryKey(options),
  });
};

/**
 * Upload an image for the given side to the provided document.
 */
export const postHostedDocumentsByIdUploadBySideMutation = (
  options?: Partial<Options<PostHostedDocumentsByIdUploadBySideData>>,
): UseMutationOptions<
  PostHostedDocumentsByIdUploadBySideResponse,
  ApiError,
  Options<PostHostedDocumentsByIdUploadBySideData>
> => {
  const mutationOptions: UseMutationOptions<
    PostHostedDocumentsByIdUploadBySideResponse,
    ApiError,
    Options<PostHostedDocumentsByIdUploadBySideData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postHostedDocumentsByIdUploadBySide({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postHostedIdentifySessionQueryKey = (options: Options<PostHostedIdentifySessionData>) =>
  createQueryKey('postHostedIdentifySession', options);

/**
 * Creates an identify session token.
 */
export const postHostedIdentifySessionOptions = (options: Options<PostHostedIdentifySessionData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postHostedIdentifySession({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postHostedIdentifySessionQueryKey(options),
  });
};

/**
 * Creates an identify session token.
 */
export const postHostedIdentifySessionMutation = (
  options?: Partial<Options<PostHostedIdentifySessionData>>,
): UseMutationOptions<PostHostedIdentifySessionResponse, ApiError, Options<PostHostedIdentifySessionData>> => {
  const mutationOptions: UseMutationOptions<
    PostHostedIdentifySessionResponse,
    ApiError,
    Options<PostHostedIdentifySessionData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postHostedIdentifySession({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postHostedIdentifySessionChallengeQueryKey = (options: Options<PostHostedIdentifySessionChallengeData>) =>
  createQueryKey('postHostedIdentifySessionChallenge', options);

/**
 * Sends a challenge to the phone number or email saved in this identify session and returns an HTTP 200
 */
export const postHostedIdentifySessionChallengeOptions = (options: Options<PostHostedIdentifySessionChallengeData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postHostedIdentifySessionChallenge({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postHostedIdentifySessionChallengeQueryKey(options),
  });
};

/**
 * Sends a challenge to the phone number or email saved in this identify session and returns an HTTP 200
 */
export const postHostedIdentifySessionChallengeMutation = (
  options?: Partial<Options<PostHostedIdentifySessionChallengeData>>,
): UseMutationOptions<
  PostHostedIdentifySessionChallengeResponse,
  ApiError,
  Options<PostHostedIdentifySessionChallengeData>
> => {
  const mutationOptions: UseMutationOptions<
    PostHostedIdentifySessionChallengeResponse,
    ApiError,
    Options<PostHostedIdentifySessionChallengeData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postHostedIdentifySessionChallenge({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postHostedIdentifySessionChallengeVerifyQueryKey = (
  options: Options<PostHostedIdentifySessionChallengeVerifyData>,
) => createQueryKey('postHostedIdentifySessionChallengeVerify', options);

/**
 * Verifies the response to a challenge
 */
export const postHostedIdentifySessionChallengeVerifyOptions = (
  options: Options<PostHostedIdentifySessionChallengeVerifyData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postHostedIdentifySessionChallengeVerify({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postHostedIdentifySessionChallengeVerifyQueryKey(options),
  });
};

/**
 * Verifies the response to a challenge
 */
export const postHostedIdentifySessionChallengeVerifyMutation = (
  options?: Partial<Options<PostHostedIdentifySessionChallengeVerifyData>>,
): UseMutationOptions<
  PostHostedIdentifySessionChallengeVerifyResponse,
  ApiError,
  Options<PostHostedIdentifySessionChallengeVerifyData>
> => {
  const mutationOptions: UseMutationOptions<
    PostHostedIdentifySessionChallengeVerifyResponse,
    ApiError,
    Options<PostHostedIdentifySessionChallengeVerifyData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postHostedIdentifySessionChallengeVerify({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postHostedIdentifySessionKbaQueryKey = (options: Options<PostHostedIdentifySessionKbaData>) =>
  createQueryKey('postHostedIdentifySessionKba', options);

/**
 * Respond to a KBA challenge to prove knowledge of existing data in the vault.
 */
export const postHostedIdentifySessionKbaOptions = (options: Options<PostHostedIdentifySessionKbaData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postHostedIdentifySessionKba({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postHostedIdentifySessionKbaQueryKey(options),
  });
};

/**
 * Respond to a KBA challenge to prove knowledge of existing data in the vault.
 */
export const postHostedIdentifySessionKbaMutation = (
  options?: Partial<Options<PostHostedIdentifySessionKbaData>>,
): UseMutationOptions<PostHostedIdentifySessionKbaResponse, ApiError, Options<PostHostedIdentifySessionKbaData>> => {
  const mutationOptions: UseMutationOptions<
    PostHostedIdentifySessionKbaResponse,
    ApiError,
    Options<PostHostedIdentifySessionKbaData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postHostedIdentifySessionKba({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getHostedIdentifySessionRequirementsQueryKey = (
  options?: Options<GetHostedIdentifySessionRequirementsData>,
) => createQueryKey('getHostedIdentifySessionRequirements', options);

/**
 * Returns the list of requirements for an identify session.
 */
export const getHostedIdentifySessionRequirementsOptions = (
  options?: Options<GetHostedIdentifySessionRequirementsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getHostedIdentifySessionRequirements({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getHostedIdentifySessionRequirementsQueryKey(options),
  });
};

/**
 * Updates the data stored in this identify session.
 */
export const patchHostedIdentifySessionVaultMutation = (
  options?: Partial<Options<PatchHostedIdentifySessionVaultData>>,
): UseMutationOptions<
  PatchHostedIdentifySessionVaultResponse,
  ApiError,
  Options<PatchHostedIdentifySessionVaultData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchHostedIdentifySessionVaultResponse,
    ApiError,
    Options<PatchHostedIdentifySessionVaultData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await patchHostedIdentifySessionVault({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postHostedIdentifySessionVerifyQueryKey = (options?: Options<PostHostedIdentifySessionVerifyData>) =>
  createQueryKey('postHostedIdentifySessionVerify', options);

/**
 * Verifies that all identify requirements have been met.
 */
export const postHostedIdentifySessionVerifyOptions = (options?: Options<PostHostedIdentifySessionVerifyData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postHostedIdentifySessionVerify({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postHostedIdentifySessionVerifyQueryKey(options),
  });
};

/**
 * Verifies that all identify requirements have been met.
 */
export const postHostedIdentifySessionVerifyMutation = (
  options?: Partial<Options<PostHostedIdentifySessionVerifyData>>,
): UseMutationOptions<
  PostHostedIdentifySessionVerifyResponse,
  ApiError,
  Options<PostHostedIdentifySessionVerifyData>
> => {
  const mutationOptions: UseMutationOptions<
    PostHostedIdentifySessionVerifyResponse,
    ApiError,
    Options<PostHostedIdentifySessionVerifyData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postHostedIdentifySessionVerify({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postHostedIdentifyValidationTokenQueryKey = (options?: Options<PostHostedIdentifyValidationTokenData>) =>
  createQueryKey('postHostedIdentifyValidationToken', options);

/**
 * Generate a validation token after the user finishes the identify flow.
 */
export const postHostedIdentifyValidationTokenOptions = (options?: Options<PostHostedIdentifyValidationTokenData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postHostedIdentifyValidationToken({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postHostedIdentifyValidationTokenQueryKey(options),
  });
};

/**
 * Generate a validation token after the user finishes the identify flow.
 */
export const postHostedIdentifyValidationTokenMutation = (
  options?: Partial<Options<PostHostedIdentifyValidationTokenData>>,
): UseMutationOptions<
  PostHostedIdentifyValidationTokenResponse,
  ApiError,
  Options<PostHostedIdentifyValidationTokenData>
> => {
  const mutationOptions: UseMutationOptions<
    PostHostedIdentifyValidationTokenResponse,
    ApiError,
    Options<PostHostedIdentifyValidationTokenData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postHostedIdentifyValidationToken({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postHostedOnboardingQueryKey = (options?: Options<PostHostedOnboardingData>) =>
  createQueryKey('postHostedOnboarding', options);

/**
 * Gets or creates the Onboarding for this (user, ob_config) pair.
 */
export const postHostedOnboardingOptions = (options?: Options<PostHostedOnboardingData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postHostedOnboarding({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postHostedOnboardingQueryKey(options),
  });
};

/**
 * Gets or creates the Onboarding for this (user, ob_config) pair.
 */
export const postHostedOnboardingMutation = (
  options?: Partial<Options<PostHostedOnboardingData>>,
): UseMutationOptions<PostHostedOnboardingResponse, ApiError, Options<PostHostedOnboardingData>> => {
  const mutationOptions: UseMutationOptions<
    PostHostedOnboardingResponse,
    ApiError,
    Options<PostHostedOnboardingData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postHostedOnboarding({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postHostedOnboardingAuthorizeQueryKey = (options?: Options<PostHostedOnboardingAuthorizeData>) =>
  createQueryKey('postHostedOnboardingAuthorize', options);

/**
 * Mark the onboarding as authorized and initiate IDV checks
 */
export const postHostedOnboardingAuthorizeOptions = (options?: Options<PostHostedOnboardingAuthorizeData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postHostedOnboardingAuthorize({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postHostedOnboardingAuthorizeQueryKey(options),
  });
};

/**
 * Mark the onboarding as authorized and initiate IDV checks
 */
export const postHostedOnboardingAuthorizeMutation = (
  options?: Partial<Options<PostHostedOnboardingAuthorizeData>>,
): UseMutationOptions<PostHostedOnboardingAuthorizeResponse, ApiError, Options<PostHostedOnboardingAuthorizeData>> => {
  const mutationOptions: UseMutationOptions<
    PostHostedOnboardingAuthorizeResponse,
    ApiError,
    Options<PostHostedOnboardingAuthorizeData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postHostedOnboardingAuthorize({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postHostedOnboardingAvisResultQueryKey = (options?: Options<PostHostedOnboardingAvisResultData>) =>
  createQueryKey('postHostedOnboardingAvisResult', options);

/**
 * Returns the workflow's status. Only available for demo tenants and POS tenants.
 */
export const postHostedOnboardingAvisResultOptions = (options?: Options<PostHostedOnboardingAvisResultData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postHostedOnboardingAvisResult({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postHostedOnboardingAvisResultQueryKey(options),
  });
};

/**
 * Returns the workflow's status. Only available for demo tenants and POS tenants.
 */
export const postHostedOnboardingAvisResultMutation = (
  options?: Partial<Options<PostHostedOnboardingAvisResultData>>,
): UseMutationOptions<
  PostHostedOnboardingAvisResultResponse,
  ApiError,
  Options<PostHostedOnboardingAvisResultData>
> => {
  const mutationOptions: UseMutationOptions<
    PostHostedOnboardingAvisResultResponse,
    ApiError,
    Options<PostHostedOnboardingAvisResultData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postHostedOnboardingAvisResult({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postHostedOnboardingBackQueryKey = (options?: Options<PostHostedOnboardingBackData>) =>
  createQueryKey('postHostedOnboardingBack', options);

/**
 * Backs up the graphical workflow to the previous node.
 */
export const postHostedOnboardingBackOptions = (options?: Options<PostHostedOnboardingBackData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postHostedOnboardingBack({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postHostedOnboardingBackQueryKey(options),
  });
};

/**
 * Backs up the graphical workflow to the previous node.
 */
export const postHostedOnboardingBackMutation = (
  options?: Partial<Options<PostHostedOnboardingBackData>>,
): UseMutationOptions<PostHostedOnboardingBackResponse, ApiError, Options<PostHostedOnboardingBackData>> => {
  const mutationOptions: UseMutationOptions<
    PostHostedOnboardingBackResponse,
    ApiError,
    Options<PostHostedOnboardingBackData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postHostedOnboardingBack({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postHostedOnboardingChallengeQueryKey = (options: Options<PostHostedOnboardingChallengeData>) =>
  createQueryKey('postHostedOnboardingChallenge', options);

/**
 * Sends an OTP challenge to the phone number or email in this onboarding's vault and returns an HTTP 200. Errors sending the challenge are surfaced on the `error` field of the response.
 */
export const postHostedOnboardingChallengeOptions = (options: Options<PostHostedOnboardingChallengeData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postHostedOnboardingChallenge({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postHostedOnboardingChallengeQueryKey(options),
  });
};

/**
 * Sends an OTP challenge to the phone number or email in this onboarding's vault and returns an HTTP 200. Errors sending the challenge are surfaced on the `error` field of the response.
 */
export const postHostedOnboardingChallengeMutation = (
  options?: Partial<Options<PostHostedOnboardingChallengeData>>,
): UseMutationOptions<PostHostedOnboardingChallengeResponse, ApiError, Options<PostHostedOnboardingChallengeData>> => {
  const mutationOptions: UseMutationOptions<
    PostHostedOnboardingChallengeResponse,
    ApiError,
    Options<PostHostedOnboardingChallengeData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postHostedOnboardingChallenge({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postHostedOnboardingChallengeVerifyQueryKey = (
  options: Options<PostHostedOnboardingChallengeVerifyData>,
) => createQueryKey('postHostedOnboardingChallengeVerify', options);

/**
 * Verifies the response to a challenge sent via POST /hosted/onboarding/challenge, recording an auth event for this workflow and marking the contact info as verified.
 */
export const postHostedOnboardingChallengeVerifyOptions = (
  options: Options<PostHostedOnboardingChallengeVerifyData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postHostedOnboardingChallengeVerify({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postHostedOnboardingChallengeVerifyQueryKey(options),
  });
};

/**
 * Verifies the response to a challenge sent via POST /hosted/onboarding/challenge, recording an auth event for this workflow and marking the contact info as verified.
 */
export const postHostedOnboardingChallengeVerifyMutation = (
  options?: Partial<Options<PostHostedOnboardingChallengeVerifyData>>,
): UseMutationOptions<
  PostHostedOnboardingChallengeVerifyResponse,
  ApiError,
  Options<PostHostedOnboardingChallengeVerifyData>
> => {
  const mutationOptions: UseMutationOptions<
    PostHostedOnboardingChallengeVerifyResponse,
    ApiError,
    Options<PostHostedOnboardingChallengeVerifyData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postHostedOnboardingChallengeVerify({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getHostedOnboardingConfigQueryKey = (options?: Options<GetHostedOnboardingConfigData>) =>
  createQueryKey('getHostedOnboardingConfig', options);

/**
 * Get the details of the current onboarding session, either via public key or via a user auth token.
 */
export const getHostedOnboardingConfigOptions = (options?: Options<GetHostedOnboardingConfigData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getHostedOnboardingConfig({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getHostedOnboardingConfigQueryKey(options),
  });
};

export const hostedOnboardingD2pGenerateQueryKey = (options: Options<HostedOnboardingD2pGenerateData>) =>
  createQueryKey('hostedOnboardingD2pGenerate', options);

/**
 * Generates a new d2p session token for the currently authenticated user. The d2p session token has a limited scope, and also includes some status metadata for syncing state across the phone and desktop.
 */
export const hostedOnboardingD2pGenerateOptions = (options: Options<HostedOnboardingD2pGenerateData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await hostedOnboardingD2pGenerate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: hostedOnboardingD2pGenerateQueryKey(options),
  });
};

/**
 * Generates a new d2p session token for the currently authenticated user. The d2p session token has a limited scope, and also includes some status metadata for syncing state across the phone and desktop.
 */
export const hostedOnboardingD2pGenerateMutation = (
  options?: Partial<Options<HostedOnboardingD2pGenerateData>>,
): UseMutationOptions<HostedOnboardingD2pGenerateResponse, ApiError, Options<HostedOnboardingD2pGenerateData>> => {
  const mutationOptions: UseMutationOptions<
    HostedOnboardingD2pGenerateResponse,
    ApiError,
    Options<HostedOnboardingD2pGenerateData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await hostedOnboardingD2pGenerate({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const hostedOnboardingD2pSmsQueryKey = (options: Options<HostedOnboardingD2pSmsData>) =>
  createQueryKey('hostedOnboardingD2pSms', options);

/**
 * Send an SMS with a link to the phone onboarding page.
 */
export const hostedOnboardingD2pSmsOptions = (options: Options<HostedOnboardingD2pSmsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await hostedOnboardingD2pSms({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: hostedOnboardingD2pSmsQueryKey(options),
  });
};

/**
 * Send an SMS with a link to the phone onboarding page.
 */
export const hostedOnboardingD2pSmsMutation = (
  options?: Partial<Options<HostedOnboardingD2pSmsData>>,
): UseMutationOptions<HostedOnboardingD2pSmsResponse, ApiError, Options<HostedOnboardingD2pSmsData>> => {
  const mutationOptions: UseMutationOptions<
    HostedOnboardingD2pSmsResponse,
    ApiError,
    Options<HostedOnboardingD2pSmsData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await hostedOnboardingD2pSms({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const hostedOnboardingD2pStatusQueryKey = (options?: Options<HostedOnboardingD2pStatusData>) =>
  createQueryKey('hostedOnboardingD2pStatus', options);

/**
 * Gets the status of the provided d2p session. Requires the d2p session token as the auth header.
 */
export const hostedOnboardingD2pStatusOptions = (options?: Options<HostedOnboardingD2pStatusData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await hostedOnboardingD2pStatus({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: hostedOnboardingD2pStatusQueryKey(options),
  });
};

export const hostedOnboardingD2pStatusPostQueryKey = (options: Options<HostedOnboardingD2pStatusPostData>) =>
  createQueryKey('hostedOnboardingD2pStatusPost', options);

/**
 * Update the status of the provided d2p session. Only allows updating to certain statuses.
 */
export const hostedOnboardingD2pStatusPostOptions = (options: Options<HostedOnboardingD2pStatusPostData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await hostedOnboardingD2pStatusPost({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: hostedOnboardingD2pStatusPostQueryKey(options),
  });
};

/**
 * Update the status of the provided d2p session. Only allows updating to certain statuses.
 */
export const hostedOnboardingD2pStatusPostMutation = (
  options?: Partial<Options<HostedOnboardingD2pStatusPostData>>,
): UseMutationOptions<HostedOnboardingD2pStatusPostResponse, ApiError, Options<HostedOnboardingD2pStatusPostData>> => {
  const mutationOptions: UseMutationOptions<
    HostedOnboardingD2pStatusPostResponse,
    ApiError,
    Options<HostedOnboardingD2pStatusPostData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await hostedOnboardingD2pStatusPost({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postHostedOnboardingFpQueryKey = (options: Options<PostHostedOnboardingFpData>) =>
  createQueryKey('postHostedOnboardingFp', options);

/**
 * Records a fingerprint visitorID for the Fingerprint SDK in the frontend
 */
export const postHostedOnboardingFpOptions = (options: Options<PostHostedOnboardingFpData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postHostedOnboardingFp({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postHostedOnboardingFpQueryKey(options),
  });
};

/**
 * Records a fingerprint visitorID for the Fingerprint SDK in the frontend
 */
export const postHostedOnboardingFpMutation = (
  options?: Partial<Options<PostHostedOnboardingFpData>>,
): UseMutationOptions<PostHostedOnboardingFpResponse, ApiError, Options<PostHostedOnboardingFpData>> => {
  const mutationOptions: UseMutationOptions<
    PostHostedOnboardingFpResponse,
    ApiError,
    Options<PostHostedOnboardingFpData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postHostedOnboardingFp({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getHostedOnboardingNidQueryKey = (options?: Options<GetHostedOnboardingNidData>) =>
  createQueryKey('getHostedOnboardingNid', options);

/**
 * Retrieve identifier used for NeuroId
 */
export const getHostedOnboardingNidOptions = (options?: Options<GetHostedOnboardingNidData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getHostedOnboardingNid({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getHostedOnboardingNidQueryKey(options),
  });
};

export const getHostedOnboardingPrefillQueryKey = (options?: Options<GetHostedOnboardingPrefillData>) =>
  createQueryKey('getHostedOnboardingPrefill', options);

/**
 * Get context on whether we can prefill data from an external match into this onboarding session.
 */
export const getHostedOnboardingPrefillOptions = (options?: Options<GetHostedOnboardingPrefillData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getHostedOnboardingPrefill({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getHostedOnboardingPrefillQueryKey(options),
  });
};

export const postHostedOnboardingPrefillQueryKey = (options: Options<PostHostedOnboardingPrefillData>) =>
  createQueryKey('postHostedOnboardingPrefill', options);

/**
 * Prefill data from the matching external vault into this vault.
 */
export const postHostedOnboardingPrefillOptions = (options: Options<PostHostedOnboardingPrefillData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postHostedOnboardingPrefill({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postHostedOnboardingPrefillQueryKey(options),
  });
};

/**
 * Prefill data from the matching external vault into this vault.
 */
export const postHostedOnboardingPrefillMutation = (
  options?: Partial<Options<PostHostedOnboardingPrefillData>>,
): UseMutationOptions<PostHostedOnboardingPrefillResponse, ApiError, Options<PostHostedOnboardingPrefillData>> => {
  const mutationOptions: UseMutationOptions<
    PostHostedOnboardingPrefillResponse,
    ApiError,
    Options<PostHostedOnboardingPrefillData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postHostedOnboardingPrefill({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postHostedOnboardingPrefillChallengeQueryKey = (
  options: Options<PostHostedOnboardingPrefillChallengeData>,
) => createQueryKey('postHostedOnboardingPrefillChallenge', options);

/**
 * Initiate a challenge to prefill data from an external match into this onboarding session.
 */
export const postHostedOnboardingPrefillChallengeOptions = (
  options: Options<PostHostedOnboardingPrefillChallengeData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postHostedOnboardingPrefillChallenge({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postHostedOnboardingPrefillChallengeQueryKey(options),
  });
};

/**
 * Initiate a challenge to prefill data from an external match into this onboarding session.
 */
export const postHostedOnboardingPrefillChallengeMutation = (
  options?: Partial<Options<PostHostedOnboardingPrefillChallengeData>>,
): UseMutationOptions<
  PostHostedOnboardingPrefillChallengeResponse,
  ApiError,
  Options<PostHostedOnboardingPrefillChallengeData>
> => {
  const mutationOptions: UseMutationOptions<
    PostHostedOnboardingPrefillChallengeResponse,
    ApiError,
    Options<PostHostedOnboardingPrefillChallengeData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postHostedOnboardingPrefillChallenge({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postHostedOnboardingPrefillVerifiedQueryKey = (
  options: Options<PostHostedOnboardingPrefillVerifiedData>,
) => createQueryKey('postHostedOnboardingPrefillVerified', options);

/**
 * Prefill data from Verified into this vault.
 */
export const postHostedOnboardingPrefillVerifiedOptions = (
  options: Options<PostHostedOnboardingPrefillVerifiedData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postHostedOnboardingPrefillVerified({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postHostedOnboardingPrefillVerifiedQueryKey(options),
  });
};

/**
 * Prefill data from Verified into this vault.
 */
export const postHostedOnboardingPrefillVerifiedMutation = (
  options?: Partial<Options<PostHostedOnboardingPrefillVerifiedData>>,
): UseMutationOptions<
  PostHostedOnboardingPrefillVerifiedResponse,
  ApiError,
  Options<PostHostedOnboardingPrefillVerifiedData>
> => {
  const mutationOptions: UseMutationOptions<
    PostHostedOnboardingPrefillVerifiedResponse,
    ApiError,
    Options<PostHostedOnboardingPrefillVerifiedData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postHostedOnboardingPrefillVerified({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postHostedOnboardingPrefillVerifiedCommitQueryKey = (
  options: Options<PostHostedOnboardingPrefillVerifiedCommitData>,
) => createQueryKey('postHostedOnboardingPrefillVerifiedCommit', options);

/**
 * Commit a prefill result and write its data to the vault.
 */
export const postHostedOnboardingPrefillVerifiedCommitOptions = (
  options: Options<PostHostedOnboardingPrefillVerifiedCommitData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postHostedOnboardingPrefillVerifiedCommit({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postHostedOnboardingPrefillVerifiedCommitQueryKey(options),
  });
};

/**
 * Commit a prefill result and write its data to the vault.
 */
export const postHostedOnboardingPrefillVerifiedCommitMutation = (
  options?: Partial<Options<PostHostedOnboardingPrefillVerifiedCommitData>>,
): UseMutationOptions<
  PostHostedOnboardingPrefillVerifiedCommitResponse,
  ApiError,
  Options<PostHostedOnboardingPrefillVerifiedCommitData>
> => {
  const mutationOptions: UseMutationOptions<
    PostHostedOnboardingPrefillVerifiedCommitResponse,
    ApiError,
    Options<PostHostedOnboardingPrefillVerifiedCommitData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postHostedOnboardingPrefillVerifiedCommit({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getHostedOnboardingPrivacyPassQueryKey = (options?: Options<GetHostedOnboardingPrivacyPassData>) =>
  createQueryKey('getHostedOnboardingPrivacyPass', options);

/**
 * initiates privacy pass protocol.
 */
export const getHostedOnboardingPrivacyPassOptions = (options?: Options<GetHostedOnboardingPrivacyPassData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getHostedOnboardingPrivacyPass({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getHostedOnboardingPrivacyPassQueryKey(options),
  });
};

export const postHostedOnboardingProceedQueryKey = (options: Options<PostHostedOnboardingProceedData>) =>
  createQueryKey('postHostedOnboardingProceed', options);

/**
 * Advances the graphical workflow if possible. Returns the next set of outstanding onboarding requirements.
 */
export const postHostedOnboardingProceedOptions = (options: Options<PostHostedOnboardingProceedData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postHostedOnboardingProceed({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postHostedOnboardingProceedQueryKey(options),
  });
};

/**
 * Advances the graphical workflow if possible. Returns the next set of outstanding onboarding requirements.
 */
export const postHostedOnboardingProceedMutation = (
  options?: Partial<Options<PostHostedOnboardingProceedData>>,
): UseMutationOptions<PostHostedOnboardingProceedResponse, ApiError, Options<PostHostedOnboardingProceedData>> => {
  const mutationOptions: UseMutationOptions<
    PostHostedOnboardingProceedResponse,
    ApiError,
    Options<PostHostedOnboardingProceedData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postHostedOnboardingProceed({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postHostedOnboardingProcessQueryKey = (options?: Options<PostHostedOnboardingProcessData>) =>
  createQueryKey('postHostedOnboardingProcess', options);

/**
 * Continue processing the onboarding after user this stage of user input has finished. Deprecated in favor of `POST /hosted/onboarding/proceed`
 */
export const postHostedOnboardingProcessOptions = (options?: Options<PostHostedOnboardingProcessData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postHostedOnboardingProcess({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postHostedOnboardingProcessQueryKey(options),
  });
};

/**
 * Continue processing the onboarding after user this stage of user input has finished. Deprecated in favor of `POST /hosted/onboarding/proceed`
 */
export const postHostedOnboardingProcessMutation = (
  options?: Partial<Options<PostHostedOnboardingProcessData>>,
): UseMutationOptions<PostHostedOnboardingProcessResponse, ApiError, Options<PostHostedOnboardingProcessData>> => {
  const mutationOptions: UseMutationOptions<
    PostHostedOnboardingProcessResponse,
    ApiError,
    Options<PostHostedOnboardingProcessData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postHostedOnboardingProcess({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postHostedOnboardingSdsQueryKey = (options: Options<PostHostedOnboardingSdsData>) =>
  createQueryKey('postHostedOnboardingSds', options);

/**
 * Records a deviceSessionId from the Socure Device SDK in the frontend
 */
export const postHostedOnboardingSdsOptions = (options: Options<PostHostedOnboardingSdsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postHostedOnboardingSds({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postHostedOnboardingSdsQueryKey(options),
  });
};

/**
 * Records a deviceSessionId from the Socure Device SDK in the frontend
 */
export const postHostedOnboardingSdsMutation = (
  options?: Partial<Options<PostHostedOnboardingSdsData>>,
): UseMutationOptions<PostHostedOnboardingSdsResponse, ApiError, Options<PostHostedOnboardingSdsData>> => {
  const mutationOptions: UseMutationOptions<
    PostHostedOnboardingSdsResponse,
    ApiError,
    Options<PostHostedOnboardingSdsData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postHostedOnboardingSds({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postHostedOnboardingSilentQueryKey = (options: Options<PostHostedOnboardingSilentData>) =>
  createQueryKey('postHostedOnboardingSilent', options);

/**
 * Runs through the identify flow and onboarding flow for a user.
 */
export const postHostedOnboardingSilentOptions = (options: Options<PostHostedOnboardingSilentData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postHostedOnboardingSilent({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postHostedOnboardingSilentQueryKey(options),
  });
};

/**
 * Runs through the identify flow and onboarding flow for a user.
 */
export const postHostedOnboardingSilentMutation = (
  options?: Partial<Options<PostHostedOnboardingSilentData>>,
): UseMutationOptions<PostHostedOnboardingSilentResponse, ApiError, Options<PostHostedOnboardingSilentData>> => {
  const mutationOptions: UseMutationOptions<
    PostHostedOnboardingSilentResponse,
    ApiError,
    Options<PostHostedOnboardingSilentData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postHostedOnboardingSilent({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postHostedOnboardingSkipPasskeyRegisterQueryKey = (
  options: Options<PostHostedOnboardingSkipPasskeyRegisterData>,
) => createQueryKey('postHostedOnboardingSkipPasskeyRegister', options);

/**
 * Tells us that a passkey registration was skipped
 */
export const postHostedOnboardingSkipPasskeyRegisterOptions = (
  options: Options<PostHostedOnboardingSkipPasskeyRegisterData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postHostedOnboardingSkipPasskeyRegister({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postHostedOnboardingSkipPasskeyRegisterQueryKey(options),
  });
};

/**
 * Tells us that a passkey registration was skipped
 */
export const postHostedOnboardingSkipPasskeyRegisterMutation = (
  options?: Partial<Options<PostHostedOnboardingSkipPasskeyRegisterData>>,
): UseMutationOptions<
  PostHostedOnboardingSkipPasskeyRegisterResponse,
  ApiError,
  Options<PostHostedOnboardingSkipPasskeyRegisterData>
> => {
  const mutationOptions: UseMutationOptions<
    PostHostedOnboardingSkipPasskeyRegisterResponse,
    ApiError,
    Options<PostHostedOnboardingSkipPasskeyRegisterData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postHostedOnboardingSkipPasskeyRegister({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getHostedOnboardingStatusQueryKey = (options?: Options<GetHostedOnboardingStatusData>) =>
  createQueryKey('getHostedOnboardingStatus', options);

/**
 * Returns the remaining onboarding requirements. Deprecated in favor of `POST /hosted/onboarding/proceed`
 */
export const getHostedOnboardingStatusOptions = (options?: Options<GetHostedOnboardingStatusData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getHostedOnboardingStatus({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getHostedOnboardingStatusQueryKey(options),
  });
};

export const postHostedOnboardingTelQueryKey = (options: Options<PostHostedOnboardingTelData>) =>
  createQueryKey('postHostedOnboardingTel', options);

/**
 * Performs a lookup with Stytch on the passed up telemetry_id and records the response + risk signals
 */
export const postHostedOnboardingTelOptions = (options: Options<PostHostedOnboardingTelData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postHostedOnboardingTel({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postHostedOnboardingTelQueryKey(options),
  });
};

/**
 * Performs a lookup with Stytch on the passed up telemetry_id and records the response + risk signals
 */
export const postHostedOnboardingTelMutation = (
  options?: Partial<Options<PostHostedOnboardingTelData>>,
): UseMutationOptions<PostHostedOnboardingTelResponse, ApiError, Options<PostHostedOnboardingTelData>> => {
  const mutationOptions: UseMutationOptions<
    PostHostedOnboardingTelResponse,
    ApiError,
    Options<PostHostedOnboardingTelData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postHostedOnboardingTel({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postHostedOnboardingTimelineQueryKey = (options: Options<PostHostedOnboardingTimelineData>) =>
  createQueryKey('postHostedOnboardingTimeline', options);

/**
 * Log a timeline event for this user using a frontend-provided page identifier
 */
export const postHostedOnboardingTimelineOptions = (options: Options<PostHostedOnboardingTimelineData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postHostedOnboardingTimeline({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postHostedOnboardingTimelineQueryKey(options),
  });
};

/**
 * Log a timeline event for this user using a frontend-provided page identifier
 */
export const postHostedOnboardingTimelineMutation = (
  options?: Partial<Options<PostHostedOnboardingTimelineData>>,
): UseMutationOptions<PostHostedOnboardingTimelineResponse, ApiError, Options<PostHostedOnboardingTimelineData>> => {
  const mutationOptions: UseMutationOptions<
    PostHostedOnboardingTimelineResponse,
    ApiError,
    Options<PostHostedOnboardingTimelineData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postHostedOnboardingTimeline({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postHostedOnboardingValidateQueryKey = (options?: Options<PostHostedOnboardingValidateData>) =>
  createQueryKey('postHostedOnboardingValidate', options);

/**
 * Finish onboarding the user. Returns the validation token that can be exchanged for a permanent Footprint user token.
 */
export const postHostedOnboardingValidateOptions = (options?: Options<PostHostedOnboardingValidateData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postHostedOnboardingValidate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postHostedOnboardingValidateQueryKey(options),
  });
};

/**
 * Finish onboarding the user. Returns the validation token that can be exchanged for a permanent Footprint user token.
 */
export const postHostedOnboardingValidateMutation = (
  options?: Partial<Options<PostHostedOnboardingValidateData>>,
): UseMutationOptions<PostHostedOnboardingValidateResponse, ApiError, Options<PostHostedOnboardingValidateData>> => {
  const mutationOptions: UseMutationOptions<
    PostHostedOnboardingValidateResponse,
    ApiError,
    Options<PostHostedOnboardingValidateData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postHostedOnboardingValidate({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postHostedSdkVersionQueryKey = (options?: Options<PostHostedSdkVersionData>) =>
  createQueryKey('postHostedSdkVersion', options);

/**
 * Record SDK version usage for a tenant.
 */
export const postHostedSdkVersionOptions = (options?: Options<PostHostedSdkVersionData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postHostedSdkVersion({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postHostedSdkVersionQueryKey(options),
  });
};

/**
 * Record SDK version usage for a tenant.
 */
export const postHostedSdkVersionMutation = (
  options?: Partial<Options<PostHostedSdkVersionData>>,
): UseMutationOptions<PostHostedSdkVersionResponse, ApiError, Options<PostHostedSdkVersionData>> => {
  const mutationOptions: UseMutationOptions<
    PostHostedSdkVersionResponse,
    ApiError,
    Options<PostHostedSdkVersionData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postHostedSdkVersion({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postHostedUserAttestDeviceQueryKey = (options: Options<PostHostedUserAttestDeviceData>) =>
  createQueryKey('postHostedUserAttestDevice', options);

/**
 * receive the attestation
 * Parses and accepts a user's onboarding device attestation
 */
export const postHostedUserAttestDeviceOptions = (options: Options<PostHostedUserAttestDeviceData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postHostedUserAttestDevice({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postHostedUserAttestDeviceQueryKey(options),
  });
};

/**
 * receive the attestation
 * Parses and accepts a user's onboarding device attestation
 */
export const postHostedUserAttestDeviceMutation = (
  options?: Partial<Options<PostHostedUserAttestDeviceData>>,
): UseMutationOptions<PostHostedUserAttestDeviceResponse, ApiError, Options<PostHostedUserAttestDeviceData>> => {
  const mutationOptions: UseMutationOptions<
    PostHostedUserAttestDeviceResponse,
    ApiError,
    Options<PostHostedUserAttestDeviceData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postHostedUserAttestDevice({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postHostedUserAttestDeviceChallengeQueryKey = (
  options: Options<PostHostedUserAttestDeviceChallengeData>,
) => createQueryKey('postHostedUserAttestDeviceChallenge', options);

/**
 * initiate the attestation challenge
 * Generate a device attestation challenge
 */
export const postHostedUserAttestDeviceChallengeOptions = (
  options: Options<PostHostedUserAttestDeviceChallengeData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postHostedUserAttestDeviceChallenge({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postHostedUserAttestDeviceChallengeQueryKey(options),
  });
};

/**
 * initiate the attestation challenge
 * Generate a device attestation challenge
 */
export const postHostedUserAttestDeviceChallengeMutation = (
  options?: Partial<Options<PostHostedUserAttestDeviceChallengeData>>,
): UseMutationOptions<
  PostHostedUserAttestDeviceChallengeResponse,
  ApiError,
  Options<PostHostedUserAttestDeviceChallengeData>
> => {
  const mutationOptions: UseMutationOptions<
    PostHostedUserAttestDeviceChallengeResponse,
    ApiError,
    Options<PostHostedUserAttestDeviceChallengeData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postHostedUserAttestDeviceChallenge({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getHostedUserAuthMethodsQueryKey = (options?: Options<GetHostedUserAuthMethodsData>) =>
  createQueryKey('getHostedUserAuthMethods', options);

/**
 * Returns information about the auth methods this user has registered.
 */
export const getHostedUserAuthMethodsOptions = (options?: Options<GetHostedUserAuthMethodsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getHostedUserAuthMethods({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getHostedUserAuthMethodsQueryKey(options),
  });
};

export const getHostedUserAuthorizedOrgsQueryKey = (options?: Options<GetHostedUserAuthorizedOrgsData>) =>
  createQueryKey('getHostedUserAuthorizedOrgs', options);

/**
 * Returns a list of organizations onto which the user has onboarded
 */
export const getHostedUserAuthorizedOrgsOptions = (options?: Options<GetHostedUserAuthorizedOrgsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getHostedUserAuthorizedOrgs({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getHostedUserAuthorizedOrgsQueryKey(options),
  });
};

export const postHostedUserChallengeQueryKey = (options: Options<PostHostedUserChallengeData>) =>
  createQueryKey('postHostedUserChallenge', options);

/**
 * Sends a challenge of the requested kind
 */
export const postHostedUserChallengeOptions = (options: Options<PostHostedUserChallengeData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postHostedUserChallenge({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postHostedUserChallengeQueryKey(options),
  });
};

/**
 * Sends a challenge of the requested kind
 */
export const postHostedUserChallengeMutation = (
  options?: Partial<Options<PostHostedUserChallengeData>>,
): UseMutationOptions<PostHostedUserChallengeResponse, ApiError, Options<PostHostedUserChallengeData>> => {
  const mutationOptions: UseMutationOptions<
    PostHostedUserChallengeResponse,
    ApiError,
    Options<PostHostedUserChallengeData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postHostedUserChallenge({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postHostedUserChallengeVerifyQueryKey = (options: Options<PostHostedUserChallengeVerifyData>) =>
  createQueryKey('postHostedUserChallengeVerify', options);

/**
 * Verify the previously sent challenge and attach the new form of contact info to the vault
 */
export const postHostedUserChallengeVerifyOptions = (options: Options<PostHostedUserChallengeVerifyData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postHostedUserChallengeVerify({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postHostedUserChallengeVerifyQueryKey(options),
  });
};

/**
 * Verify the previously sent challenge and attach the new form of contact info to the vault
 */
export const postHostedUserChallengeVerifyMutation = (
  options?: Partial<Options<PostHostedUserChallengeVerifyData>>,
): UseMutationOptions<PostHostedUserChallengeVerifyResponse, ApiError, Options<PostHostedUserChallengeVerifyData>> => {
  const mutationOptions: UseMutationOptions<
    PostHostedUserChallengeVerifyResponse,
    ApiError,
    Options<PostHostedUserChallengeVerifyData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postHostedUserChallengeVerify({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postHostedUserConsentQueryKey = (options: Options<PostHostedUserConsentData>) =>
  createQueryKey('postHostedUserConsent', options);

/**
 * Records a user's consent to some terms.
 */
export const postHostedUserConsentOptions = (options: Options<PostHostedUserConsentData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postHostedUserConsent({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postHostedUserConsentQueryKey(options),
  });
};

/**
 * Records a user's consent to some terms.
 */
export const postHostedUserConsentMutation = (
  options?: Partial<Options<PostHostedUserConsentData>>,
): UseMutationOptions<PostHostedUserConsentResponse, ApiError, Options<PostHostedUserConsentData>> => {
  const mutationOptions: UseMutationOptions<
    PostHostedUserConsentResponse,
    ApiError,
    Options<PostHostedUserConsentData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postHostedUserConsent({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postHostedUserDocumentsQueryKey = (options: Options<PostHostedUserDocumentsData>) =>
  createQueryKey('postHostedUserDocuments', options);

/**
 * Create a new document for the outstanding document request
 */
export const postHostedUserDocumentsOptions = (options: Options<PostHostedUserDocumentsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postHostedUserDocuments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postHostedUserDocumentsQueryKey(options),
  });
};

/**
 * Create a new document for the outstanding document request
 */
export const postHostedUserDocumentsMutation = (
  options?: Partial<Options<PostHostedUserDocumentsData>>,
): UseMutationOptions<PostHostedUserDocumentsResponse, ApiError, Options<PostHostedUserDocumentsData>> => {
  const mutationOptions: UseMutationOptions<
    PostHostedUserDocumentsResponse,
    ApiError,
    Options<PostHostedUserDocumentsData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postHostedUserDocuments({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postHostedUserDocumentsByIdProcessQueryKey = (options: Options<PostHostedUserDocumentsByIdProcessData>) =>
  createQueryKey('postHostedUserDocumentsByIdProcess', options);

/**
 * Process the document and run any vendor verifications.
 */
export const postHostedUserDocumentsByIdProcessOptions = (options: Options<PostHostedUserDocumentsByIdProcessData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postHostedUserDocumentsByIdProcess({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postHostedUserDocumentsByIdProcessQueryKey(options),
  });
};

/**
 * Process the document and run any vendor verifications.
 */
export const postHostedUserDocumentsByIdProcessMutation = (
  options?: Partial<Options<PostHostedUserDocumentsByIdProcessData>>,
): UseMutationOptions<
  PostHostedUserDocumentsByIdProcessResponse,
  ApiError,
  Options<PostHostedUserDocumentsByIdProcessData>
> => {
  const mutationOptions: UseMutationOptions<
    PostHostedUserDocumentsByIdProcessResponse,
    ApiError,
    Options<PostHostedUserDocumentsByIdProcessData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postHostedUserDocumentsByIdProcess({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postHostedUserDocumentsByIdUploadBySideQueryKey = (
  options: Options<PostHostedUserDocumentsByIdUploadBySideData>,
) => createQueryKey('postHostedUserDocumentsByIdUploadBySide', options);

/**
 * Upload an image for the given side to the provided document.
 */
export const postHostedUserDocumentsByIdUploadBySideOptions = (
  options: Options<PostHostedUserDocumentsByIdUploadBySideData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postHostedUserDocumentsByIdUploadBySide({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postHostedUserDocumentsByIdUploadBySideQueryKey(options),
  });
};

/**
 * Upload an image for the given side to the provided document.
 */
export const postHostedUserDocumentsByIdUploadBySideMutation = (
  options?: Partial<Options<PostHostedUserDocumentsByIdUploadBySideData>>,
): UseMutationOptions<
  PostHostedUserDocumentsByIdUploadBySideResponse,
  ApiError,
  Options<PostHostedUserDocumentsByIdUploadBySideData>
> => {
  const mutationOptions: UseMutationOptions<
    PostHostedUserDocumentsByIdUploadBySideResponse,
    ApiError,
    Options<PostHostedUserDocumentsByIdUploadBySideData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postHostedUserDocumentsByIdUploadBySide({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postHostedUserEmailVerifyQueryKey = (options: Options<PostHostedUserEmailVerifyData>) =>
  createQueryKey('postHostedUserEmailVerify', options);

/**
 * Used to asynchronously verify a user's email address. Requires the token sent to the users email.
 */
export const postHostedUserEmailVerifyOptions = (options: Options<PostHostedUserEmailVerifyData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postHostedUserEmailVerify({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postHostedUserEmailVerifyQueryKey(options),
  });
};

/**
 * Used to asynchronously verify a user's email address. Requires the token sent to the users email.
 */
export const postHostedUserEmailVerifyMutation = (
  options?: Partial<Options<PostHostedUserEmailVerifyData>>,
): UseMutationOptions<PostHostedUserEmailVerifyResponse, ApiError, Options<PostHostedUserEmailVerifyData>> => {
  const mutationOptions: UseMutationOptions<
    PostHostedUserEmailVerifyResponse,
    ApiError,
    Options<PostHostedUserEmailVerifyData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postHostedUserEmailVerify({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postHostedUserExpireSessionQueryKey = (options?: Options<PostHostedUserExpireSessionData>) =>
  createQueryKey('postHostedUserExpireSession', options);

/**
 * Expires the session defined by `x-fp-authorization`
 */
export const postHostedUserExpireSessionOptions = (options?: Options<PostHostedUserExpireSessionData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postHostedUserExpireSession({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postHostedUserExpireSessionQueryKey(options),
  });
};

/**
 * Expires the session defined by `x-fp-authorization`
 */
export const postHostedUserExpireSessionMutation = (
  options?: Partial<Options<PostHostedUserExpireSessionData>>,
): UseMutationOptions<PostHostedUserExpireSessionResponse, ApiError, Options<PostHostedUserExpireSessionData>> => {
  const mutationOptions: UseMutationOptions<
    PostHostedUserExpireSessionResponse,
    ApiError,
    Options<PostHostedUserExpireSessionData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postHostedUserExpireSession({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getHostedUserPrivateTokenQueryKey = (options?: Options<GetHostedUserPrivateTokenData>) =>
  createQueryKey('getHostedUserPrivateToken', options);

/**
 * Returns information about the auth token. Can only be used in sandbox mode for demo tenants.
 */
export const getHostedUserPrivateTokenOptions = (options?: Options<GetHostedUserPrivateTokenData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getHostedUserPrivateToken({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getHostedUserPrivateTokenQueryKey(options),
  });
};

export const getHostedUserTokenQueryKey = (options?: Options<GetHostedUserTokenData>) =>
  createQueryKey('getHostedUserToken', options);

/**
 * Returns information about a given auth token.
 */
export const getHostedUserTokenOptions = (options?: Options<GetHostedUserTokenData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getHostedUserToken({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getHostedUserTokenQueryKey(options),
  });
};

export const postHostedUserTokensQueryKey = (options: Options<PostHostedUserTokensData>) =>
  createQueryKey('postHostedUserTokens', options);

/**
 * Create a new token with the requested scopes using the permissions granted by the existing token. Used to create a secondary token with more limited scope. The new token's expiry time is the same as the old token's
 */
export const postHostedUserTokensOptions = (options: Options<PostHostedUserTokensData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postHostedUserTokens({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postHostedUserTokensQueryKey(options),
  });
};

/**
 * Create a new token with the requested scopes using the permissions granted by the existing token. Used to create a secondary token with more limited scope. The new token's expiry time is the same as the old token's
 */
export const postHostedUserTokensMutation = (
  options?: Partial<Options<PostHostedUserTokensData>>,
): UseMutationOptions<PostHostedUserTokensResponse, ApiError, Options<PostHostedUserTokensData>> => {
  const mutationOptions: UseMutationOptions<
    PostHostedUserTokensResponse,
    ApiError,
    Options<PostHostedUserTokensData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postHostedUserTokens({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postHostedUserUploadByDocumentIdentifierQueryKey = (
  options: Options<PostHostedUserUploadByDocumentIdentifierData>,
) => createQueryKey('postHostedUserUploadByDocumentIdentifier', options);

/**
 * POSTs a document to the vault
 */
export const postHostedUserUploadByDocumentIdentifierOptions = (
  options: Options<PostHostedUserUploadByDocumentIdentifierData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postHostedUserUploadByDocumentIdentifier({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postHostedUserUploadByDocumentIdentifierQueryKey(options),
  });
};

/**
 * POSTs a document to the vault
 */
export const postHostedUserUploadByDocumentIdentifierMutation = (
  options?: Partial<Options<PostHostedUserUploadByDocumentIdentifierData>>,
): UseMutationOptions<
  PostHostedUserUploadByDocumentIdentifierResponse,
  ApiError,
  Options<PostHostedUserUploadByDocumentIdentifierData>
> => {
  const mutationOptions: UseMutationOptions<
    PostHostedUserUploadByDocumentIdentifierResponse,
    ApiError,
    Options<PostHostedUserUploadByDocumentIdentifierData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postHostedUserUploadByDocumentIdentifier({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Updates data in a user vault
 */
export const patchHostedUserVaultMutation = (
  options?: Partial<Options<PatchHostedUserVaultData>>,
): UseMutationOptions<PatchHostedUserVaultResponse, ApiError, Options<PatchHostedUserVaultData>> => {
  const mutationOptions: UseMutationOptions<
    PatchHostedUserVaultResponse,
    ApiError,
    Options<PatchHostedUserVaultData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await patchHostedUserVault({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postHostedUserVaultDecryptQueryKey = (options: Options<PostHostedUserVaultDecryptData>) =>
  createQueryKey('postHostedUserVaultDecrypt', options);

/**
 * Decrypts the specified list of fields from the provided vault.
 */
export const postHostedUserVaultDecryptOptions = (options: Options<PostHostedUserVaultDecryptData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postHostedUserVaultDecrypt({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postHostedUserVaultDecryptQueryKey(options),
  });
};

/**
 * Decrypts the specified list of fields from the provided vault.
 */
export const postHostedUserVaultDecryptMutation = (
  options?: Partial<Options<PostHostedUserVaultDecryptData>>,
): UseMutationOptions<PostHostedUserVaultDecryptResponse, ApiError, Options<PostHostedUserVaultDecryptData>> => {
  const mutationOptions: UseMutationOptions<
    PostHostedUserVaultDecryptResponse,
    ApiError,
    Options<PostHostedUserVaultDecryptData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postHostedUserVaultDecrypt({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postHostedUserVaultValidateQueryKey = (options: Options<PostHostedUserVaultValidateData>) =>
  createQueryKey('postHostedUserVaultValidate', options);

/**
 * Checks if provided vault data is valid before adding it to the vault
 */
export const postHostedUserVaultValidateOptions = (options: Options<PostHostedUserVaultValidateData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postHostedUserVaultValidate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postHostedUserVaultValidateQueryKey(options),
  });
};

/**
 * Checks if provided vault data is valid before adding it to the vault
 */
export const postHostedUserVaultValidateMutation = (
  options?: Partial<Options<PostHostedUserVaultValidateData>>,
): UseMutationOptions<PostHostedUserVaultValidateResponse, ApiError, Options<PostHostedUserVaultValidateData>> => {
  const mutationOptions: UseMutationOptions<
    PostHostedUserVaultValidateResponse,
    ApiError,
    Options<PostHostedUserVaultValidateData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postHostedUserVaultValidate({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrgSdkArgsQueryKey = (options?: Options<GetOrgSdkArgsData>) => createQueryKey('getOrgSdkArgs', options);

/**
 * Fetch information from an existing SDK args session.
 */
export const getOrgSdkArgsOptions = (options?: Options<GetOrgSdkArgsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrgSdkArgs({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrgSdkArgsQueryKey(options),
  });
};

export const postOrgSdkArgsQueryKey = (options: Options<PostOrgSdkArgsData>) =>
  createQueryKey('postOrgSdkArgs', options);

/**
 * Create a new session containing args for the SDK.
 */
export const postOrgSdkArgsOptions = (options: Options<PostOrgSdkArgsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgSdkArgs({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgSdkArgsQueryKey(options),
  });
};

/**
 * Create a new session containing args for the SDK.
 */
export const postOrgSdkArgsMutation = (
  options?: Partial<Options<PostOrgSdkArgsData>>,
): UseMutationOptions<PostOrgSdkArgsResponse, ApiError, Options<PostOrgSdkArgsData>> => {
  const mutationOptions: UseMutationOptions<PostOrgSdkArgsResponse, ApiError, Options<PostOrgSdkArgsData>> = {
    mutationFn: async localOptions => {
      const { data } = await postOrgSdkArgs({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const postOrgSdkTelemetryQueryKey = (options: Options<PostOrgSdkTelemetryData>) =>
  createQueryKey('postOrgSdkTelemetry', options);

/**
 * Log contents of the HTTP body.
 */
export const postOrgSdkTelemetryOptions = (options: Options<PostOrgSdkTelemetryData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postOrgSdkTelemetry({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: postOrgSdkTelemetryQueryKey(options),
  });
};

/**
 * Log contents of the HTTP body.
 */
export const postOrgSdkTelemetryMutation = (
  options?: Partial<Options<PostOrgSdkTelemetryData>>,
): UseMutationOptions<PostOrgSdkTelemetryResponse, ApiError, Options<PostOrgSdkTelemetryData>> => {
  const mutationOptions: UseMutationOptions<PostOrgSdkTelemetryResponse, ApiError, Options<PostOrgSdkTelemetryData>> = {
    mutationFn: async localOptions => {
      const { data } = await postOrgSdkTelemetry({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};
